import styled from 'styled-components'
import { breakpoints } from '../../constants/breakpoints.constants'

export const StyledRegulation = styled.div`
	strong {
		font-size: 22px;
		line-height: 60px;
	}

	li {
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 10px;
	}

	p {
		font-size: 20px;
		text-align: justify;
	}
`

export const FormGrid = styled.div`
		display: grid;
		gap: 25px;
		grid-template-columns: 1fr;

		@media screen and (min-width: ${breakpoints.MEDIUM_SCREEN}px) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media screen and (min-width: ${breakpoints.LAPTOP}px) {
			grid-template-columns: repeat(3, 1fr);
		}
	`

